import { CUSTOMER_AGENT_GLOBAL_HANDOFFS, HELP_DESK_ROUTING_SCOPE_FILTERING, ROUTING_AWAY_STATUS_TIMER, TEAMS_ONLY_ROUTING, USER_LEVEL_CAPACITY_LIMITS, USER_LEVEL_CAPACITY_LIMITS_TICKET_TYPE, USAGE_BASED_BILLING_INBOUND_2025 } from '../constants/gates';
import { memoizedGatesSet, useUserInfo } from './useUserInfo';
export const useGates = () => memoizedGatesSet(useUserInfo());
export const useGate = gate => useGates().has(gate);
export const createUngatedHook = gate => () => useGate(gate);

/*
  Put individual gate-check hooks below this comment
  For single gate checks, just do `const useHasMyGate = createUngatedHook(MY_GATE)`
  Since hooks should not be called conditionally, for multi-gate checks, do
    const useIsUngatedForMultiple = () => {
      const gates = useGates();

      return gates.has(MY_GATE) &&
        gates.has(OTHER_GATE) &&
          gates.has(THIRD_GATE);
    };
*/
export const useIsUngatedForHelpDeskRoutingScopeFiltering = createUngatedHook(HELP_DESK_ROUTING_SCOPE_FILTERING);
export const useIsUngatedForUserLevelCapacityLimits = createUngatedHook(USER_LEVEL_CAPACITY_LIMITS);
export const useIsUngatedForUserLevelCapacityLimitsTicketType = createUngatedHook(USER_LEVEL_CAPACITY_LIMITS_TICKET_TYPE);
export const useIsUngatedForTeamsOnly = createUngatedHook(TEAMS_ONLY_ROUTING);
export const useIsUngatedForRoutingAwayStatusTimer = createUngatedHook(ROUTING_AWAY_STATUS_TIMER);
export const useIsUngatedForInboundCredits = createUngatedHook(USAGE_BASED_BILLING_INBOUND_2025);
export const useIsUngatedForCustomerAgentGlobalHandoffs = createUngatedHook(CUSTOMER_AGENT_GLOBAL_HANDOFFS);